// extracted by mini-css-extract-plugin
export default {"centeredColumn":"UserTable_centeredColumn__cLB-N"};